export default __webpack_public_path__ + "static/media/arrow-left-blurple.4bb8bfc5.svg";